import { CookieManager } from './cookie';

let mapsInitialized = false;
export class MapsManager {


    static checkCookies() {
        if (CookieManager.getCookie('cookie_consent') === 'accepted') {
            MapsManager.init();
        }
    }

    static init() {
        if (mapsInitialized === true || typeof initMap !== 'function') {
            return;
        }

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.defer = true;
        script.async = true;
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBeOQCZtjTz7MmW1KX-kXxWA7Fwar9ODb4&callback=initMap&language=de&region=GER';
        document.head.appendChild(script);

        mapsInitialized = true;
    }
}
